export const CODE_LENGTH = 6;
export const MIN_PASSWORD = 6;
export const MAX_PASSWORD = 128;
export const DEFAULT_COOLDOWN = 60;

export const sanitizeCode = (value) =>
  String(value || "").replace(/\D/g, "").slice(0, CODE_LENGTH);

// Returns an error message, or "" when the input is valid.
export function validateReset({ code, password, confirm }) {
  if (!new RegExp(`^\\d{${CODE_LENGTH}}$`).test(code)) {
    return `Enter the ${CODE_LENGTH}-digit code from your email.`;
  }
  if (password.length < MIN_PASSWORD || password.length > MAX_PASSWORD) {
    return `Password must be ${MIN_PASSWORD} to ${MAX_PASSWORD} characters.`;
  }
  if (password !== confirm) return "Passwords do not match.";
  return "";
}

export function secondsLeft(deadline, now) {
  return Math.max(0, Math.ceil((deadline - now) / 1000));
}

// Maps a failed result from passwordResetApi to text for the user.
export function failureMessage(result, action) {
  if (result.network) {
    return "Could not reach the server. Check your connection and try again.";
  }
  if (result.status === 429) {
    return action === "confirm"
      ? "Too many incorrect attempts. Request a new code and try again."
      : `Too many requests. Please wait${
          result.retryAfter ? ` ${result.retryAfter} seconds` : " a moment"
        } and try again.`;
  }
  if (result.status === 503) {
    return "Password reset is not available right now. Please try again shortly.";
  }
  if (result.status === 400 && result.message) return result.message;
  return "Something went wrong. Please try again.";
}
